import { useCallback, useState } from 'react';

export const useToggleKeys = <Key extends string>(
  allKeys: Key[] | readonly Key[],
  initialKeys: Key[] = []
) => {
  const [keys, setKeys] = useState<Key[] | readonly Key[]>(initialKeys);

  const isEnabled = useCallback((key: Key) => keys.includes(key), [keys]);

  const toggle = useCallback((key: Key) => {
    setKeys((prevKeys) =>
      prevKeys.includes(key)
        ? prevKeys.filter((k) => k !== key)
        : [...prevKeys, key]
    );
  }, []);

  const clear = useCallback(() => setKeys([]), []);

  const fill = useCallback(() => setKeys(allKeys), [allKeys]);

  return { isEnabled, toggle, clear, fill };
};
